import React from 'react';
import {Link, generatePath} from 'react-router-dom';
import routes from 'globals/routes';
import { useDataValue } from 'globals/contexts/dataContext';

import './bannerSection.css';
import './bannerSectionMobile.css';

const BannerSection = (props) => {
  const [{currentLanguage}, dispatch] = useDataValue();
  const pageContent = props['content'];
  return <section className="banner" id="banner">
    <div className="background">
      {{
        ['image']: <img src={pageContent['media']['src']} />,
        ['video']: <video src={pageContent['media']['src']} />,
      }[pageContent['media']['type']]}
    </div>
    <div className="content">
      <div className="title">{pageContent['title']}</div>
      <div className="brief">{pageContent['brief']}</div>
      <Link to={generatePath(routes[pageContent['url']], { lang: currentLanguage})}><button>{pageContent['buttonText']}</button></Link>
    </div>
  </section>;
}
export default BannerSection;